import { IconContent } from '@icons';

export const tasksFilled: IconContent = {
    md: '<path d="M4 5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3.5V3h-1v2h-7V3h-1v2H4Zm0 14v-9h16v10H4v-1Zm14-5v-1h-5v1h5Zm0 1v1h-5v-1h5Zm0 3v-1h-5v1h5Zm-9.896-1.021 3.125-3.125-.708-.708-2.771 2.772-1.396-1.397-.708.708 1.75 1.75.354.353.354-.353Z" />',
};
